// LeadSummaryStyles.tsx
export const LeadSummaryStyles = {
  container: "flex flex-col md:flex-row md:space-x-8",
  tableContainer:
    "w-full md:w-1/3 p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-300 dark:border-gray-600",
  titleContainer: "flex justify-center items-center mb-2",
  title: "text-theme-xl font-semibold text-gray-900 dark:text-gray-200",
  table: "w-full border-collapse",
  thead: "bg-gray-100 dark:bg-gray-600",
  th: "p-2 text-left text-gray-700 dark:text-gray-300 border-b border-gray-200 dark:border-gray-600",
  td: "p-2 text-gray-900 dark:text-gray-100 border-b border-gray-200 dark:border-gray-600",
  linkedTd:
    "p-2 text-theme-xs text-blue-500 dark:text-blue-400 hover:underline border-b border-gray-200 dark:border-gray-600",
  viewMore:
    "block w-full text-center mt-4 p-2 bg-gray-100 dark:bg-gray-600 text-gray-900 dark:text-gray-100 hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors",
  loading: "text-center py-4",
  error: "text-center py-4 text-red-500",
};